import type { ICartLiteEntityResponse, IProductEntityCart, ICartCRUDItem } from '../models';
import type { ICartLiteResponse, ICartLiteResponseItem, ICartUpdateDto } from '#shared/api';

import { getCartUpdateDto } from './getCartUpdateDto';

export class CartLiteMapper {
  static getResponseFromApi(response: ICartLiteResponse): ICartLiteEntityResponse {
    return {
      id: response.id,
      totalGoodsCount: response.totalGoodsCount,
      totalBasePrice: response.totalBasePrice,
      totalFinalPrice: response.totalFinalPrice,
      updatedAt: response.updatedAt,
      products: response.items?.map((it) => this.getCartProductEntity(it)) ?? [],
    };
  }

  private static getCartProductEntity(productFromApi: ICartLiteResponseItem): IProductEntityCart {
    return {
      skuId: productFromApi.goodId,
      amount: productFromApi.qnty,
      isSelected: productFromApi.selected,
    };
  }

  static getCartUpdateDTO(items: ICartCRUDItem[]): ICartUpdateDto {
    return getCartUpdateDto(items);
  }
}
